/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="140" height="140" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M96.487 32.115c4.501 1.614 10.588-2.63 10.682-8.812.089-5.61-2.512-8.157-5.532-8.801-7.547-1.603-11.498 4.594-9.164 13.06.696 2.536 2.313 3.945 4.014 4.553zm26.069 23.984c5.454 13.888-1.308 18.462-7.703 30.506-2.68 5.05-4.465 10.546-6.553 15.858-3.396 8.618-8.656 19.766-17.726 22.926-9.085 3.164-17.903-1.997-18.155-14.224-.167-8.115 2.209-15.79 9.578-20.935 3.077-2.153 4.61-4.605 5.688-8.434 5.24-18.599-4.851-24.298-.34-36.117 7.694-20.154 29.046-4.474 34.97 9.838.089.194.168.388.241.582zm6.799-12.862c5.95 2.562-1.057 10.185-5.129 8.943a2.84 2.84 0 01-1.492-1.079c-2.909-3.94 2.748-9.514 6.621-7.864z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M113.812 24.44c9.116.168 4.626 12.285-1.314 12.762-.832.068-1.69-.094-2.543-.545-6.035-3.196-2.068-12.306 3.857-12.217zm9.708 9.546c7.264 1.566 1.146 10.896-3.705 10.367a3.45 3.45 0 01-1.921-.848c-4.166-3.594.9-10.52 5.626-9.52zm8.503 18.341c5.124 2.21-.931 8.833-4.443 7.764a2.462 2.462 0 01-1.282-.927c-2.502-3.416 2.392-8.262 5.725-6.837zM48.635 27.594c2.68-8.361-1.01-14.716-8.62-13.428-3.04.514-5.741 2.95-5.888 8.56-.162 6.183 5.747 10.672 10.305 9.248 1.727-.54 3.397-1.876 4.203-4.38zM17.652 54.28c6.51-14.05 28.501-28.829 35.347-8.376 4.014 11.997-6.301 17.272-1.842 36.075.92 3.871 2.35 6.386 5.338 8.665 7.149 5.448 9.206 13.213 8.698 21.317-.759 12.207-9.782 16.995-18.73 13.459-8.934-3.536-13.723-14.889-16.759-23.643-1.868-5.391-3.422-10.96-5.892-16.115-5.888-12.301-12.45-17.152-6.427-30.8.089-.199.178-.393.267-.581zm-.235-4.426c-.435.54-.958.864-1.534 1.016-4.118 1.069-10.802-6.837-4.752-9.147 3.936-1.493 9.358 4.312 6.286 8.13z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M30.787 35.955c-.87.414-1.733.54-2.56.44-5.913-.723-9.901-13.013-.785-12.804 5.925.152 9.51 9.42 3.345 12.364zm-8.217 6.507a3.48 3.48 0 01-1.951.77c-4.873.33-10.593-9.252-3.271-10.51 4.757-.806 9.535 6.33 5.223 9.74zM13.522 57.76a2.444 2.444 0 01-1.319.874c-3.553.922-9.33-5.946-4.118-7.942 3.39-1.283 8.08 3.756 5.437 7.067z"
      clipRule="evenodd"
    ></path>
  </Svg>
)

export default Icon
